import { createErrorNotification } from "../toaster/creators";
import { addNotification } from "../toaster/actions";
import { Observable } from "rxjs";
const errorNotification = createErrorNotification("Failed to lock ASCII file", {
    showIcon: false,
});
export function createNotificationOnLockErrorEpic(ActionKeys) {
    return (actions$) => actions$
        .ofType(ActionKeys.ERROR)
        .mergeMap(() => Observable.of(addNotification(errorNotification)));
}
//# sourceMappingURL=lockErNotification.js.map